import BreadCrumb from '@/data/BreadCrumb';
import NavigationTree from '@/data/NavigationTree';

export default class BreadCrumbsHelper {

  private homeValue: string;
  private searchValue: string;
  public static readonly homePseudoChannelId = -767;
  public static readonly homeSearchChannelId = -768;

  constructor(homeItemText: string, searchItemText: string) {
    this.homeValue = homeItemText;
    this.searchValue = searchItemText;
  }

  public getBreadCrumbs(navigationTree: NavigationTree): Array<BreadCrumb> {

    const breadCrumbs = new Array<BreadCrumb>();
    breadCrumbs.push(new BreadCrumb(navigationTree.id, navigationTree.nameLocalized));
    while(navigationTree.level > 1 && navigationTree.hasParent() && navigationTree.parent) {
      navigationTree = navigationTree.parent;
      breadCrumbs.push(new BreadCrumb(navigationTree.id, navigationTree.nameLocalized));
    }
    breadCrumbs.push(this.getHomeBreadCrumb());
    return breadCrumbs.reverse();
  }

  public getHomeBreadCrumb() {
    return new BreadCrumb(BreadCrumbsHelper.homePseudoChannelId, this.homeValue);
  }

  public getSearchBreadCrumb() {
    return new BreadCrumb(BreadCrumbsHelper.homeSearchChannelId, this.searchValue);
  }

  public getHomeBreadCrumbs(): Array<BreadCrumb> {
    return [this.getHomeBreadCrumb()];
  }

  public getSearchBreadCrumbs(): Array<BreadCrumb> {
    return [this.getHomeBreadCrumb(), this.getSearchBreadCrumb()];
  }
}
